import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { it } from "./locales/it.js";
import { en } from "./locales/en.js";

export const SUPPORTED_LANGUAGES = ["it", "en"] as const;
export type AppLanguage = (typeof SUPPORTED_LANGUAGES)[number];

const STORAGE_KEY = "kappa.lang";

function initialLanguage(): AppLanguage {
  const stored = (typeof localStorage !== "undefined" && localStorage.getItem(STORAGE_KEY)) as AppLanguage | null;
  if (stored && SUPPORTED_LANGUAGES.includes(stored)) return stored;
  return "it";
}

i18n.use(initReactI18next).init({
  resources: {
    it: { translation: it },
    en: { translation: en }
  },
  lng: initialLanguage(),
  fallbackLng: "it",
  interpolation: { escapeValue: false }
});

/** Cambia lingua e la persiste per le sessioni successive. */
export function changeLanguage(lang: AppLanguage): void {
  i18n.changeLanguage(lang);
  if (typeof localStorage !== "undefined") localStorage.setItem(STORAGE_KEY, lang);
}

export default i18n;
